export const FIELD_CATEGORIES = {
  Personal: [
    { value: "first_name", label: "First Name" },
    { value: "last_name", label: "Last Name" },
    { value: "title", label: "Title" },
    { value: "middle_names", label: "Middle Name(s)" },
    { value: "date_of_birth", label: "Date of Birth" },
    { value: "national_insurance_number", label: "National Insurance Number" },
    { value: "sex", label: "Sex (Male, Female, Not known)" },
  ],
  "Contact Information": [
    { value: "street_address", label: "Street Address" },
    { value: "city", label: "City" },
    { value: "country", label: "Country" },
    { value: "post_code", label: "Post Code" },
    { value: "telephone_number", label: "Telephone Number" },
    { value: "email", label: "Email" },
  ],
  "Employment Information": [
    { value: "company_name", label: "Company name" },
    { value: "date_joined_employer", label: "Date Joined Employer" },
    { value: "date_of_leaving", label: "Date Of Leaving" },
    { value: "date_of_retirement", label: "Date Of Retirement" },
    { value: "date_joined_company", label: "Date joined company" },
    { value: "normal_retirement_date", label: "Normal Retirement Date" },
    { value: "date_of_death", label: "Date Of Death" },
    {
      value: "final_pensionable_salary",
      label: "Final Pensionable Salary",
      guidance:
        "The final salary earned by the member used to calculate the pension entitlement this might be their last salary before retirement or some other definition per the scheme rules",
    },
  ],
  "Personal Pension Information": [
    { value: "pension_provider_name", label: "Pension provider name" },
    { value: "date_joined_scheme", label: "Date joined scheme" },
    { value: "pension_status", label: "Pension status (active, retired, deferred)" },
    { value: "member_scheme_id", label: "Member Scheme ID" },
    { value: "pension_scheme_id", label: "Pension Scheme ID" },
    { value: "scheme_member_category", label: "Scheme Member Category" },
    { value: "nominated_beneficiary_name", label: "Nominated Beneficiary Name" },
    { value: "nominated_beneficiary_relationship", label: "Nominated Beneficiary Relationship" },
    { value: "nominated_beneficiary_address", label: "Nominated Beneficiary Address" },
    { value: "pension_monthly_payment_date", label: "Pension Monthly Payment Date" },
    { value: "post_88_gmp_pension", label: "Post-88 GMP Monthly Pension" },
    { value: "gmp_pension", label: "GMP Monthly Pension" },
    { value: "basic_pension", label: "Basic Monthly Pension" },
  ],
};

export const DEFAULT_FIELDS = Object.values(FIELD_CATEGORIES)
  .flat()
  .map((field) => field.value);
